// src/context/Datacontext.js
import { set } from "date-fns";
import { createContext } from "react";

export const Datacontext = createContext({
  blogs: [],
  setBlogs: () => {},
  magazines: [],
  setMagazines: () => {},
  Highlight:[],
  setHighlight:()=>{},
  loading: true,
  refetch: () => {}, // We'll use this in admin
});